import { render } from "./PartnerAndClient.vue?vue&type=template&id=6e89380e"
import script from "./PartnerAndClient.vue?vue&type=script&lang=js"
export * from "./PartnerAndClient.vue?vue&type=script&lang=js"

import "./PartnerAndClient.vue?vue&type=style&index=0&id=6e89380e&lang=scss"
script.render = render

export default script